export default "__VITE_ASSET__3e332773__"